import { S } from "node_modules/vite/dist/node/types.d-aGj9QkWt";
import BaseApiServiceV2 from "./BaseApiServiceV2";
import StorageManager from "../helpers/StorageManager";
import { getContextId, setContextId, readContextIdFromResponse, ensureContextId } from "../helpers/ContextId";

class HomeServices extends BaseApiServiceV2 {
  /**
   * @param {String} id
   * @returns Promise<Object>
   * @memberof SearchService
   */



  getHomeSummary(region: string) {
    return this.apiGetWithCache(`/api/home/region-summary/${region}`);
  }

  getFeaturedPlaces(region: string) {
    return this.apiGetWithCache(`/city-profile/areas/by-country-iso/${region}?isFeatured=true&spacetype=Office Space`);
  }

  getCitiesByRegion(region: string, spaceType: string) {
    return this.apiGetWithCache(`/city-profile/areas/by-country-iso/${region}?spacetype=${spaceType}`)
  }

  private async apiGetWithCache(path: string) {
    let url: string;
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "public, max-age=600, s-maxage=1200, stale-while-revalidate=86400",
    };

    if (typeof window === "undefined") {
      // ---------------------------------------------------------
      // SERVER SIDE: Direct Call + Secret Helper
      // ---------------------------------------------------------
      const baseUrl = process.env.REMIX_APP_API_HOST_V2 || "https://apiv2dev.office-hub.com";
      url = `${baseUrl}${path}`;

      // Inject Secret if available
      if (process.env.API_SECRET_KEY) {
        // console.log("HomeServices (Server): Injecting Secret");
        headers["x-api-secret"] = process.env.API_SECRET_KEY;
      }
    } else {
      // ---------------------------------------------------------
      // CLIENT SIDE: Use Proxy (No Secret Exposed)
      // ---------------------------------------------------------
      url = `/api/proxy${path}`;
    }

    const token = StorageManager.get("token");
    if (token) {
      headers["Authorization"] = token;
    }

    const ctx = ensureContextId();
    if (ctx) headers["X-Context-Id"] = ctx;

    const response = await fetch(url, {
      method: "GET",
      headers,
    });
    const ctxFromRes = readContextIdFromResponse(response);
    if (ctxFromRes) setContextId(ctxFromRes);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.log("FROM HomeServices");
      console.log("OH-ERROR", JSON.stringify(errorData, null, 2));
      throw new Error(response.statusText);
    }
    return response.json();
  }


}
export default new HomeServices();
